export const addNewButtonStyles = theme => ({
  marginLeft: theme.spacing(3),
});

export const filterCounterStyles = theme => ({
  alignItems: 'center',
  backgroundColor: theme.palette.primary.light,
  borderRadius: 2,
  color: theme.palette.primary.main,
  display: 'flex',
  fontSize: 12,
  height: 16,
  justifyContent: 'center',
  marginLeft: theme.spacing(1),
  padding: 2,
  width: 14,
});

export const filterWrapStyles = {
  alignSelf: 'end',
};

export const headerClassStyles = {
  alignSelf: 'end',
  minWidth: '65%',
};

export const headerContainerStyles = theme => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  overflow: 'hidden',
  padding: theme.spacing(3),
  textOverflow: 'ellipsis',
});

export const subHeaderClassStyles = {
  alignSelf: 'start',
  gridRowStart: 2,
};
